export default "__VITE_ASSET__q$gU8KLt__"